'use strict';

exports['default'] = '0.10.19';


//////////////////
// WEBPACK FOOTER
// ./node_modules/mobiledoc-kit/dist/commonjs/mobiledoc-kit/version.js
// module id = 1510
// module chunks = 0